<template>
    <transition name="fade">
        <div
            v-if="!loadComplete"
            class="wrapper">

            <!-- PROGRESS BOX -->
            <div class="progress-box">

                <!-- PROGRESS PERC (0%) -->
                <div class="progress-perc">
                    {{ progressPerc }}
                </div>

                <!-- PROGRESS BAR -->
                <div class="progress-bar mb-3">
                    <div
                        class="progress-bar-fill"
                        :style="{ transform: 'scaleX('+ progressXScale +')'}">
                    </div>
                </div>

                <!-- STATUS -->
                <!-- <div v-html="status"></div> -->

                <!-- FILE PROGRESS -->
                <!-- <div>{{ fileProgress }}<span class="perc">%</span></div> -->
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            manifest: {
                type: Array,
                required: true
            }
        },
        data() { // https://www.npmjs.com/package/manifest-glob-loader  -- GLOB LOADER ?
            return {
                loadQueue: null,
                fileProgress: 0, // 100%
                loadComplete: false,
                progress: 0, // 0.000
                progressPerc: 0, // 100%
                progressXScale: 0, // 0.1
                status: '',
            }
        },
        watch: {
            manifest() {
                this.init();
            }
        },
        created() {
            this.init();
        },
        beforeDestroy() {
            this.destroy();
        },
        methods: {
            init() {
                this.destroy();

                // Instantiate a queue.
                let queue = this.loadQueue = new createjs.LoadQueue(true); // true?

                //createjs.Sound.registerPlugins([createjs.HTMLAudioPlugin]);  // need this so it doesn't default to Web Audio
                queue.installPlugin(createjs.Sound); // must
                // createjs.Sound.registerSounds(this.manifest);

                queue.loadManifest(this.manifest);
                queue.setMaxConnections(5);

                //--------------------------------------------------------------------
                // FILE LOAD
                //--------------------------------------------------------------------

                queue.addEventListener('fileload', (event) => {
                    this.status += '[' + event.item.id + ' loaded]' + '<br>';
                    // if (event.item.type == 'sound') createjs.Sound.play(event.item.src);
                });

                //--------------------------------------------------------------------
                // ON FILE PROGRESS
                //--------------------------------------------------------------------

                queue.addEventListener('fileprogress', (event) => {
                   let progress = Math.round(event.loaded * 100);
                   // if (this.fileProgress < 100) ??
                   this.fileProgress = progress; // individual loading bars
                })

                //--------------------------------------------------------------------
                // PROGRESS TEXT (%)
                //--------------------------------------------------------------------

                queue.addEventListener('progress', (event) => {
                    this.progress = Math.round(event.loaded * 100) / 1000000;
                    this.progressPerc = Math.round(event.loaded * 100);
                    this.progressXScale = event.loaded * 1; // used for scaleX
                })

                //--------------------------------------------------------------------
                // ERROR
                //--------------------------------------------------------------------

                queue.addEventListener('error', (event) => {
                    this.status = 'Error: '+ event.text;
                });

                //--------------------------------------------------------------------
                // COMPLETE
                //--------------------------------------------------------------------

                queue.addEventListener('complete', (event) => {
                    this.status = 'Complete';
                    this.loadComplete = true;
                    // createjs.Sound.play('startup');
                });
            },
            destroy() {
                this.loadQueue = null;
            }
        },
    }
</script>

<style lang="scss" scoped>

    //-----------------------------------------------------------------
    // TRANSITION
    //-----------------------------------------------------------------

    .fade-enter-active {
        // transition: opacity 0.5s ease;
    }

    .fade-leave-active {
        // transition: opacity 1s 1s ease;
    }

    .fade-enter,
    .fade-leave-to {
        // opacity: 0;
    }

    //-----------------------------------------------------------------
    // WRAPPER
    //-----------------------------------------------------------------

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: black; // needs to match index.html
        z-index: 9999;
        // -webkit-backdrop-filter: blur(10px); // doesn't work in Chrome
    }

    //-----------------------------------------------------------------
    // PROGRESS BOX
    //-----------------------------------------------------------------

    .progress-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        text-align: center;
        width: 180px;
        // height: 150px;
        // border: 1px solid white;
        // filter: blur(0.8px); // score
    }

    // .text {
    //     font-family: 'Perfect DOS';
    //     font-size: rem-calc(18);
    //     color: transparent;
    //     text-shadow: 0 0 2px rgba(#b9deff, 1);
    // }

    //-----------------------------------------------------------------
    // PROGRESS PERC
    //-----------------------------------------------------------------

    .progress-perc {
        display: flex;
        margin-bottom: rem-calc(20);
        font-family: 'Bebas Neue';
        font-weight: 100;
        font-size: rem-calc(45); // 45
        line-height: 1;
        color: $primary;
        // color: transparent;
        // text-shadow: 0 0 2px rgba($primary, 1); //#b9deff
        filter: blur(0.8px); // score
    }

    //-----------------------------------------------------------------
    // PROGRESS BAR
    //-----------------------------------------------------------------

    .progress-bar {
        width: 100%;
        height: 4px;
        // border: 1px solid $primary;
        background: darken($primary, 40%);
        box-shadow: 0px 0px 10px darken($primary, 40%);
    }

    //-----------------------------------------------------------------
    // PROGRESS BAR FILL
    //-----------------------------------------------------------------

    .progress-bar-fill {
        width: 100%;
        height: 4px;
        box-shadow: 0px 0px 6px $primary;
        background: $primary;
        transform-origin: left;
        filter: blur(0.4px); // score
        transition: transform 500ms ease-out;
    }
</style>